import './routes';



// WEBPACK FOOTER //
// ./~/@girder/ldap/main.js